import { useStore } from 'zustand';
import { ContentMetadataState } from '@goldcast/player-config/src/types/content-metadata-store-types';
import {
  ContentMetadataStoreFactoryType,
  createContentMetadataStore
} from '@goldcast/player-config/src/stores/contentMetadataStoreFactory';
import appLogger from '@/services/logger';

const contentMetadataStore: ContentMetadataStoreFactoryType = createContentMetadataStore(appLogger);

function useContentMetadataStoreHook<U>(selector: (state: ContentMetadataState) => U): U {
  return useStore(contentMetadataStore, selector);
}

export const useContentMetadataStore = Object.assign(useContentMetadataStoreHook, contentMetadataStore);
